import $http from '../../../axios-instance';
import Swal from 'sweetalert2';

/**
 * Registrar una orden.
 * @param payload: order, start_date, quantity, company_id, comment,state
 * @returns {Promise} orden creada
 * @autor Paul Valencia
 */
export async function createOrder({commit}, payload) {
    commit('dashboard/load', true, {root: true});

    const response = await $http.post('et_orders/create', payload).then(async (response) => {
        commit('dashboard/load', false, {root: true});
        return Promise.resolve(response.data);

    }).catch(async (error) => {
        commit('dashboard/load', false, {root: true});
        if (error.message) {
            let message = error.message.order[0];
            if (error.message.order[0] == 'El valor del campo order ya está en uso.') {
                message = `El número de orden ${payload.order} ya se encuentra registrada`
            }
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    });
    commit('dashboard/load', false, {root: true});
    return Promise.resolve(response);

}

/**
 * Obtener las órdenes por empresa con paginación.
 * @param state.filter: company_id, page, per_page, sortBy, sort
 * @returns {Promise} lista de órdenes
 * @autor Paul Valencia
 */
export async function getOrdersByEmploy({commit, state}) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.get('et_orders', {params: state.filter})
        commit('setOrdersCompany', response.data);
        if (!response.data.data.length) {
            await Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'No se encontraron ordenes',
                showConfirmButton: false,
                timer: 3000
            });
        }
    } catch (error) {
        commit('dashboard/load', false, {root: true});
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Obtener todas las Órdenes de una empresa.
 * @param company_id
 * @returns void
 * @autor Paul Valencia
 */
export async function getAllOrdersByEmploy({commit}, company_id) {
    try {
        const response = await $http.get(`et_orders-all/${company_id}`);
        commit('setOrdersCompany', response.data);
        if (!response.data.length) {
            await Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'No se encontraron ordenes',
                showConfirmButton: false,
                timer: 3000
            });
        }
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    }

}


/**
 * Obtener todas las Órdenes de una empresa.
 * @param company_id
 * @returns void
 * @autor Paul Valencia
 */
export async function getOrdersWithQuanity({commit}, company_id) {
    try {
        const response = await $http.get(`et_orders-with-quantity/${company_id}`);
        commit('setOrdersCompany', response.data);
        if (!response.data.length) {
            await Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'No se encontraron ordenes',
                showConfirmButton: false,
                timer: 3000
            });
        }
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    }

}


/**
 * Actualizar una orden.
 * @param payload: id, order, start_date, quantity, company_id, comment, state
 * @returns {Promise} orden actualizada
 * @autor Paul Valencia
 */
export async function updateOrder({commit}, payload) {
    try {
        commit('dashboard/load', true, {root: true});
        const response = await $http.put(`et_orders/${payload.id}/update`, payload);
        commit('updateOrder', response.data.data)
        return Promise.resolve(response.data);
    } catch (error) {
        if (error.message) {
            let message = error.message.order[0];
            if (error.message.order[0] == 'El valor del campo order ya está en uso.') {
                message = `El número de orden ${payload.order} ya se encuentra registrada`
            }
            await Swal.fire({
                position: 'center',
                icon: 'error',
                title: message,
                showConfirmButton: false,
                timer: 2000
            });
        }
    } finally {
        commit('dashboard/load', false, {root: true});
    }
}

/**
 * Cambiar el estado de una orden a inactivo para simular la eliminación.
 *
 * @param payload: id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function deleteOrder(context, {id, company_id}) {
    await $http.patch(`et_orders/${id}/delete`, {company_id}).then(async (response) => {
        await Swal.fire({
            position: 'center',
            icon: 'success',
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
        });
    }).catch(async (error) => {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    });
}


/**
 * Mostrar el detalle de una orden.
 *
 * @param payload: order_id, company_id
 * @autor Paul Valencia
 * @returns company_id
 */
export async function orderDetails({commit}, {order_id, company_id}) {
    try {
        const response = await $http.get(`et_orders/${order_id}/show`, {params: {company_id}});
        commit('setOrder', response.data);
    } catch (error) {
        await Swal.fire({
            position: 'center',
            icon: 'error',
            title: error.message,
            showConfirmButton: false,
            timer: 2000
        });
    }
}


/**
 * Obtener empresas filtro
 *
 * @param nombre
 */
export async function getCompaniesFilter({commit, dispatch}, nombre) {
    dispatch('getCompaniesPetition', nombre)
        .then(empresas => commit('setCompanyFilter', empresas));
}


/**
 * Obtener empresas
 *
 * @param nombre
 */
export async function getCompaniesPetition({commit, state}, name) {

    return await new Promise(async (resolve, reject) => {
        if (!state.loading_data_select && name && name.length > 1) {
            commit('setLoadingDataSelect', true);

            let parametros = {
                params: {
                    nombre: name
                }
            };
            await $http.get('/empresas/lista', parametros)
                .then((response) => {
                    resolve(response.data.data);
                    commit('setLoadingDataSelect', false);
                })
                .catch(() => {
                    reject([]);
                    commit('setLoadingDataSelect', false);
                });
        }
    });
}






